<template>
    <div class="content-container">
        <div class="container">
            <div class="row">

                <!-- Title -->
                <div class="col-12">
                    <div class="title mt-5">
                        <h1>Select a drop-off location</h1>
                    </div>
                </div>

                <!-- Options -->
                <div class="col-12">
                    <template v-if="currentStoreAllowsInStoreDropOff">
                        <label>This store:</label>
                        <div class="card-list">
                            <div class="selectable-card"
                                 @click="selectStore(store.id)"
                                 :class="{'active': requestedDropOffStoreId === store.id}">
                                <div class="card-body justify-content-between">
                                    <p>{{ store.name }} <span class="text-sm">- {{ store.address.town }}</span></p>
                                    <p class="d-flex align-items-center" v-if="currentStoreDistance > 0">
                                        {{ currentStoreDistance }} Miles
                                    </p>
                                </div>
                            </div>
                        </div>
                        <label>Other locations:</label>
                    </template>
                    <loading-state v-if="loading"></loading-state>
                    <div class="card-list" v-else>
                        <div v-for="(store, index) in closestDropOffStores" :key="index" class="selectable-card"
                             @click="selectStore(store.id)"
                             :class="{'active': requestedDropOffStoreId === store.id}">
                            <div class="card-body justify-content-between">
                                <p>{{ store.name }} <span class="text-sm">- {{ store.address.town }}</span></p>
                                <p class="d-flex align-items-center">
                                    {{ store.distance }} Miles
                                </p>
                            </div>
                        </div>
<!--                            <button class="btn btn-outline-secondary btn-rounded btn-load-more btn-sm mb-4 mt-2 mx-auto">Load more locations</button>-->
                    </div>
                </div>
            </div>
            <!-- Footer -->
            <footer class="footer" :class="footerClass">
                <div class="container">
                    <router-link :to="{ name: 'repairOptions'}" class="btn btn-outline-secondary back-btn btn-lg"><i class="fa fa-chevron-left text-sm mr-3"></i> Back</router-link>
                    <router-link :to="{ name: 'dropOffLocationDetails' }" :disabled="!requestedDropOffStoreId" class="btn btn-primary btn-lg continue-btn icon-right ml-auto">Next <i class="fa fa-chevron-right ml-3 text-sm"></i></router-link>
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

    export default {
        data() {
            return {
                loading: true,
                rawClosestDropOffStores: [],
                currentStoreDistance: 0
            }
        },

        mounted() {
            // Select the current store if it has drop off enabled
            if(this.allowsStoreDropOff) {
                if(this.store) {
                    this.setRequestedDropOffStoreId(this.store.id);
                }
            }
            this.getClosestDropOffEnabledStores({
                postcode: this.bookingPostcode,
                carrier: this.carrier
            }).then(response => {
                this.loading = false
                this.rawClosestDropOffStores = response.data
            });
        },

        computed: {
            ...mapGetters([
                'carrier',
                'store',
                'requestedDropOffStoreId',
                'bookingPostcode',
                'currentStoreAllowsInStoreDropOff'
            ]),

            allowsStoreDropOff() {
                return (this.store) ? this.store.drop_off_available : false;
            },

            /**
             * Return the closest stores without the current store, while grabbing the distance for the current store
             * so we do not have to grab this separately
             */
            closestDropOffStores() {
                return this.rawClosestDropOffStores.filter(store => {
                    if(store.id !== this.store.id) {
                        return true;
                    } else {
                        this.currentStoreDistance = store.distance;
                    }
                    return store.id !== this.store.id
                })
            },

            footerClass() {
                return (window.innerHeight < 768) ? "fixed-footer" : "";
            }
        },

        methods: {
            ...mapActions([
                'getClosestDropOffEnabledStores',
                'setRequestedDropOffStoreId'
            ]),

            /** Select the store */
            selectStore(storeId) {
                this.setRequestedDropOffStoreId(storeId);
            }
        }
    }
</script>

<style scoped>

</style>